import { Delete } from '@mui/icons-material'
import { IconButton, Stack, Typography } from '@mui/material'

type CardNumberProps = {
  cardNumber: string
  onDelete: (cardNumber: string) => void
}

export default function CardNumber({ cardNumber, onDelete }: CardNumberProps) {
  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontFamily: 'monospace' }}
      >
        XXXX-XXXX-XXXX-{cardNumber}
      </Typography>

      <IconButton
        size="small"
        color="error"
        onClick={() => onDelete(cardNumber)}
      >
        <Delete sx={{ fontSize: 14 }} />
      </IconButton>
    </Stack>
  )
}
